export const VIEW_VEHICLE_SUGGESTIONS = "VIEW_VEHICLE_SUGGESTIONS"
export const VIEW_VEHICLE_SUGGESTIONS_SUCCESS = "VIEW_VEHICLE_SUGGESTIONS_SUCCESS"
export const VIEW_VEHICLE_SUGGESTIONS_FAIL = "VIEW_VEHICLE_SUGGESTIONS_FAIL"

export const APPROVE_VEHICLE_SUGGESTIONS = "APPROVE_VEHICLE_SUGGESTIONS"
export const APPROVE_VEHICLE_SUGGESTIONS_SUCCESS = "APPROVE_VEHICLE_SUGGESTIONS_SUCCESS"
export const APPROVE_VEHICLE_SUGGESTIONS_FAIL = "APPROVE_VEHICLE_SUGGESTIONS_FAIL"

export const REJECT_VEHICLE_SUGGESTIONS = "REJECT_VEHICLE_SUGGESTIONS"
export const REJECT_VEHICLE_SUGGESTIONS_SUCCESS = "REJECT_VEHICLE_SUGGESTIONS_SUCCESS"
export const REJECT_VEHICLE_SUGGESTIONS_FAIL = "REJECT_VEHICLE_SUGGESTIONS_FAIL"

export const ADD_VEHICLE = "ADD_VEHICLE"
export const ADD_VEHICLE_SUCCESS = "ADD_VEHICLE_SUCCESS"
export const ADD_VEHICLE_FAIL = "ADD_VEHICLE_FAIL"


export const SEND_SUGGESTION_EMAIL = "SEND_SUGGESTION_EMAIL"
export const SEND_SUGGESTION_EMAIL_SUCCESS = "SEND_SUGGESTION_EMAIL_SUCCESS"
export const SEND_SUGGESTION_EMAIL_FAILED = "SEND_SUGGESTION_EMAIL_FAILED"

export const CHANGE_ACTION = "CHANGE_ACTION"
export const CHANGE_ACTION_SUCCESS = "CHANGE_ACTION_SUCCESS"
export const CHANGE_ACTION_FAIL = "CHANGE_ACTION_FAIL"